import Axios from "axios";
import Utils from "../../resources/Utils";
const { ecommerce } =require("../../config")

const SUCCESS = 200;

export const authenticateApi = async () => {
    let token = null
    let data = {
        username: ecommerce.AUTH_USERNAME,
        password: ecommerce.AUTH_PASSWORD
    }
    const _encrypted = Utils.encryptData(data)
    const body = { data: _encrypted }
    try {
        let options = {
            method: 'POST',
            url: `${ecommerce.HOST}/ClientAuth/authenticate`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: body
        }
        const response = await Axios(options)
        if (response.status === SUCCESS && response.data) {
            const decrypted = Utils.decryptData(response.data)
            token = decrypted?.token
        }
        return token
    } catch (error) {
        console.log(`error in authenticate:${error}`)
        return error
    }
}




